import ABSService from "./absService";

class LoginService extends ABSService {
    constructor() {
        super("");
    }

    login = async (loginData) => {
        let loginResult = this.requestHelper.post('/api/login', loginData);
        return loginResult;
    }

    logout = async () => {
        let loginResult = this.requestHelper.post('/api/logout');
        return loginResult;
    }

    getCookieToken() {
        return this.requestHelper.token || this.requestHelper.parseCookie().token;
    }

    setToken = async(token) => {
        this.requestHelper.setToken(token);
    }

    getCurrent = async () => {
        let loginResult = this.requestHelper.get('/api/current');
        return loginResult;
    }

    getRececntApp = async () => {
        let rs = this.requestHelper.get('/api/recent');
        return rs;
    }
}

export default LoginService;
